import { useState, useEffect, RefObject } from 'react';
import { FORMITEM_WIDTH } from './useSearchTableForm';
import { SuperFormItemProps } from '../interface';
import { BODY_WIDTH } from '../../constants/constant';

interface FormItemOption {
  baseFormItems: SuperFormItemProps[];
  highFormItems: SuperFormItemProps[];
}
function useFormItems(
  wrapper: RefObject<HTMLDivElement>,
  formItems: SuperFormItemProps[],
  highSearch?: boolean,
) {
  const [formItemOption, setFormItemOption] = useState<FormItemOption>({
    baseFormItems: highSearch ? formItems : [],
    highFormItems: [],
  });
  useEffect(() => {
    if (highSearch) return;
    const timer = setTimeout(() => {
      if (Array.isArray(formItems) && formItems.length && wrapper.current) {
        let parentElementWidth = wrapper.current.clientWidth || BODY_WIDTH - 40;
        if (parentElementWidth) {
          parentElementWidth = parentElementWidth - 184;
        } else {
          parentElementWidth = document.body.clientWidth - 100 - 184;
        }
        const baseFormItems: SuperFormItemProps[] = [];
        const highFormItems: SuperFormItemProps[] = [];
        let currentWidth = 0;
        formItems.forEach(formItem => {
          const { formItemType } = formItem;
          // @ts-ignore
          currentWidth = currentWidth + (formItem.width || FORMITEM_WIDTH[formItemType] || 0);
          if (currentWidth < parentElementWidth) {
            baseFormItems.push(formItem);
          } else {
            highFormItems.push(formItem);
          }
        });
        setFormItemOption({ baseFormItems, highFormItems });
      }
    });
    return () => {
      clearTimeout(timer);
    };
  }, [formItems, wrapper]);
  return formItemOption;
}

export default useFormItems;
